import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=fd883860&scoped=true&"
import script from "./MultipleSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=fd883860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd883860",
  null
  
)

export default component.exports